<template>
  <section>
    <div
      class="top-regions"
      ref="topRegions"
      :class="{ _expanded: isExpanded, 'top-regions_thumbs': withThumbs }"
      :style="styleVars"
    >
      <div
        v-if="withThumbs"
        class="w-100"
        :style="{ height: separatorHeight + 'px' }"
      ></div>
      <div
        ref="regionItem"
        class="region-item"
        v-for="(region, idx) in regionsWithNoThumbsData"
        :key="idx"
      >
        <div class="region-item__inner font-m">
          <a
            class="region-item__link"
            :href="
              getDomainType('travelone', 'skione')
                ? getUrl(region.link)
                : getUrl(region.url)
            "
            :title="region.nazwa"
          >
            {{ region.nazwa }}
          </a>
          <span class="region-item__price"
            >od <span class="font-20">{{ region.cena }}</span> zł/os.</span
          >
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="collapser-line" v-if="showToggle">
      <div @click="handleExpand()" class="collapser-line__button">
        <span class="collapser-line__label">{{
          isExpanded ? "Mniej regionów" : "Więcej regionów"
        }}</span>
        <span :class="{ _flip: isExpanded }" class="up-down-arrow"
          ><span></span><span></span
        ></span>
      </div>
    </div>
  </section>
</template>

<script>
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  mixins: [domainTypeMixin],
  props: {
    regionsWithNoThumbsData: [Array, Object],
    withThumbs: Boolean,
  },
  data: () => ({
    itemHeight: 0,
    regionsWrapperHeight: 0,
    regionsMaxWrapperHeight: 0,
    separatorHeight: 24,
    isExpanded: false,
    showToggle: false,
    windowWidth: window.innerWidth,
  }),
  methods: {
    handleExpand() {
      this.isExpanded = !this.isExpanded;

      if (!this.isExpanded && this.windowWidth <= 992) {
        this.$parent.$emit("scrollToRegionsTop");
      }
    },
    getUrl(url) {
      if (url.indexOf("www.") != -1) {
        let index = url.indexOf(".pl/");
        let stay = this.getDomainType("travelone", "skione") ? "&pobyt=7" : "";
        return url.substring(index + 3) + stay;
      } else {
        return "https://" + url;
      }
    },
    handleResize() {
      if (this.regionsWithNoThumbsData.length) {
        const regionsWrapper = this.$refs.topRegions;
        const item = this.$refs.regionItem[0];

        this.itemHeight = item.clientHeight - 1;
        this.regionsWrapperHeight =
          regionsWrapper.clientHeight + this.separatorHeight + 42;
        this.regionsMaxWrapperHeight =
          this.regionsWithNoThumbsData.length * this.itemHeight +
          this.separatorHeight +
          42;
      }
    },
    showToggleButton() {
      if (!this.withThumbs) {
        if (this.regionsWithNoThumbsData.length > 6) {
          this.showToggle = true;
        }
      } else {
        if (this.regionsWithNoThumbsData.length) {
          this.showToggle = true;
        }
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  mounted() {
    this.showToggleButton();
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  updated() {
    this.showToggleButton();
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize, { passive: true });
  },
  computed: {
    styleVars() {
      let cssVars =
        "--tr-height: " +
        this.itemHeight +
        "px;" +
        "--tr-mheight: " +
        (this.regionsMaxWrapperHeight + 180) +
        "px;";
      return cssVars;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-regions {
  max-height: calc(6 * var(--tr-height));
  overflow: hidden;

  @media (min-width: $screen-xs) {
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
    margin-right: -12px;
    max-height: calc(3 * var(--tr-height));
  }

  @media (min-width: $screen-md) {
    max-height: calc(2 * var(--tr-height));
  }

  &_thumbs {
    max-height: 0;

    @media (min-width: $screen-xs) {
      max-height: 0;
    }

    @media (min-width: $screen-md) {
      max-height: 0;
    }
  }

  &._expanded {
    max-height: calc(var(--tr-mheight));

    @media (min-width: $screen-xs) {
      max-height: calc(var(--tr-mheight) / 2);
    }

    @media (min-width: $screen-md) {
      max-height: calc(var(--tr-mheight) / 3);
    }
  }
}

.region-item {
  position: relative;
  padding-bottom: 18px;

  @media (min-width: $screen-xs) {
    padding: 0 12px 24px;
    width: 50%;
  }

  @media (min-width: $screen-md) {
    width: percentage(1/3);
  }

  &__inner {
    border: 1px solid $border-color;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 14px 12px;
    position: relative;
    height: 100%;

    &:hover {
      @include shadow();
    }
  }

  &__link {
    @include text-truncate();
    color: $text-color-default;
    display: block;
    padding-right: 24px;
    text-decoration: none;

    &::after {
      content: "";
      background: transparent;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }

    @media (min-width: $screen-md) {
      padding-right: 0;
      margin-bottom: 2px;
    }
  }

  &__price {
    color: #eb3e27;
    white-space: nowrap;
  }
}
</style>
